module.exports = __webpack_public_path__ + "static/media/sneha.c6ac0e7b.jpg";